module.exports = __webpack_public_path__ + "img/saas_3.78924f96.png";